function WhyChooseUs() {
  return (
    <section className="why">
      <h2>Why Furry Lovers Choose Us </h2>
      <div className="why-grid">
        <div>Premium Quality</div>
        <div>Fast Delivery</div>
        <div>Approved Comfort</div>
      </div>
    </section>
  );
}

export default WhyChooseUs;